<template>
  <div>
    <el-cascader
      :value="value"
      @input="updateValue"
      :options="REGIONDATA"
      :placeholder="placeholder"
      clearable
      style="width: 100%"
    ></el-cascader>
  </div>
</template>

<script>
import { regionData, regionDataPlus } from "element-china-area-data";
export default {
  name: "region", //地区
  props: {
    value: {
      type: Array,
      required: true
    },
    isAll: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "地区"
    }
  },
  data() {
    return {
      REGIONDATA: this.isAll ? regionDataPlus : regionData
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="less" scoped></style>
